import { operate } from '../util/lift';
import { OperatorSubscriber } from './OperatorSubscriber';
export function skip(count) {
    return operate((source, subscriber) => {
        let seen = 0;
        source.subscribe(new OperatorSubscriber(subscriber, (value) => (count === seen ? subscriber.next(value) : seen++)));
    });
}
//# sourceMappingURL=skip.js.map